import { BaseReducerState, Bill, Response } from '../../../services'
import { ActionTypes } from '../actions'

export interface MarkDefaulterAPIResponse extends Response {
  data: Bill
}

export type MarkDefaulterState = BaseReducerState & {
  data: Bill
}

const markDefaulterInitialState: MarkDefaulterState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const markDefaulterReducer = (
  state: MarkDefaulterState = markDefaulterInitialState,
  action: { type: string; res: any }
): MarkDefaulterState => {
  switch (action.type) {
    case `${ActionTypes.MARK_DEFAULTER}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.MARK_DEFAULTER}_SUCCESS`: {
      const { success, data, message } = <MarkDefaulterAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.MARK_DEFAULTER}_FAILURE`:
      const res = <MarkDefaulterAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.MARK_DEFAULTER}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
